<template>
    <q-table
            v-if="logs.length"
            hide-bottom
            row-key="name"
            :data="logs"
            :columns="columns"
    >
        <q-td slot="body-cell-edit" slot-scope="props" class="text-right">
            <q-btn
                    @click="deleteLog(props.value)"
                    icon="delete"
                    flat
                    round
                    color="negative"
            />
        </q-td>
    </q-table>
    <div
            v-else
    >
        Отсутствуют
    </div>
</template>

<script>
    import { mapState } from "vuex";

    import {
        QTable,
        QTd,
        QBtn,
    } from 'quasar';


    export default {
        name: 'ProjectLogs',
        components: {
            QTable,
            QTd,
            QBtn,
        },
        computed: {
            ...mapState({
                logs: state => state.project.logs
            }),
            projectId() {
                return this.$route.params.id;
            }
        },
        data() {
            return {
                columns: [
                    {
                        label: 'Тип',
                        field: 'type',
                        name: 'type',
                        sortable: false,
                        align: 'left',
                    },
                    {
                        label: 'Лог',
                        field: 'log',
                        name: 'log',
                        sortable: false,
                        align: 'left',
                    },
                    {
                        label: 'Домен',
                        field: 'domain',
                        name: 'domain',
                        sortable: false,
                        align: 'left',
                    },
                    {
                        label: 'Дата создания',
                        field: 'created_at',
                        name: 'created_at',
                        sortable: true,
                        filter: '',
                        align: 'left'
                    },
                    {
                        label: 'Дата обновления',
                        field: 'updated_at',
                        name: 'updated_at',
                        sortable: true,
                        filter: '',
                        align: 'left'
                    },
                    {
                        label: 'Действия',
                        field: 'id',
                        name: 'edit',
                        sortable: false,
                        align: 'right',
                    },
                ]
            }
        },
        mounted () {
            this.$store.dispatch('project/fetchLogs', this.projectId);
        },
        methods: {
            deleteLog (logId) {
                const projectId = this.projectId;
                if (confirm(`Вы действительно хотите удалить эту запись?`)) {
                    this.$store.dispatch('project/deleteLog', { projectId, logId }).then((response) => {
                        if (response) {
                            this.$q.notify({message: 'Запись успешно удалена', type: 'info'});
                        } else {
                            this.$q.notify({message: 'Не удалось удалить запись', type: 'negative'});
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectLogs/ProjectLogs.vue